export default __webpack_public_path__ + "static/media/cone.ac789bdf.png";